import React from "react";
import "./style.css";

import loaderIcon from "../../../Icons/support-loader.svg";

const SupportLoader: React.FC = () => {
  return (
    <div className="spin-icon">
      <img src={loaderIcon} />
    </div>
  );
};
export default SupportLoader;
